import { Navigate } from 'react-router-dom';
import { useSnapshot } from 'valtio';
import { ADMIN_DEFAULT_LANDING } from '../../../constants/adminNav';
import { roleStore, Role } from '../../../store/roleStore';
import GuestCancelledBookingsPage from './GuestCancelledBookingsPage';
import HostCancelledBookingsPage from './HostCancelledBookingsPage';

const CancelledBookingsPage = () => {
  const { role } = useSnapshot(roleStore);

  if (role === Role.ADMIN) {
    return <Navigate to={ADMIN_DEFAULT_LANDING} replace />;
  }

  return role === Role.GUEST ? <GuestCancelledBookingsPage /> : <HostCancelledBookingsPage />;
};

export default CancelledBookingsPage;
